import * as utils from '@intrasync/utils';
import { Popover } from "@mui/material";
import { action, makeObservable, observable } from "mobx";
import React from "react";

import Button from "./Button";
import { ButtonPropTypes } from "./buttonPropsTypes";
import injectStores from "../RootStore/injectStores";

interface MenuButtonProps extends ButtonPropTypes {
  menu:
    | React.ComponentType
    | React.ComponentType<{ closeMenu: () => void }>
    | (() => JSX.Element);
  menuStyle?: React.CSSProperties;
  loading?: boolean;
  tooltip?: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  disabled?: boolean;
  justIcon?: boolean;
  size?: "small" | "medium" | "large";
  autosize?: boolean;
  color?:
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "danger"
    | "gray"
    | "white"
    | "transparent";
  round?: boolean;
  fullWidth?: boolean;
  simple?: boolean;
  block?: boolean;
  link?: boolean;
}

class MenuButtonComponent extends React.PureComponent<MenuButtonProps> {
  static defaultProps = {
    disabled: false,
    color: "gray" as const,
    simple: false,
    round: false,
    fullWidth: false,
    block: false,
    link: false,
    justIcon: false,
    menuStyle: {},
  };

  anchor: HTMLElement | null = null;

  constructor(props: MenuButtonProps) {
    super(props);
    makeObservable(this, {
      anchor: observable,
      handlePopover: action,
      // openPopover: computed,
      // functionOrClassMenu: computed,
    });
  }

  handlePopover = (event: React.MouseEvent<HTMLElement> | null) => {
    if (!event) {
      this.anchor = null;
      return;
    }
    this.anchor = event.currentTarget;
  };

  get openPopover() {
    return !!this.anchor;
  }

  get functionOrClassMenu() {
    const { menu } = this.props;
    return typeof menu === "function";
  }

  render() {
    const {
      tooltip,
      disabled,
      justIcon,
      size,
      autosize,
      color,
      round,
      fullWidth,
      loading,
      children,
      menuStyle,
      menu: PopoverMenu,
    } = this.props;

    return (
      <>
        <Button
          disabled={disabled}
          justIcon={justIcon}
          size={size}
          autosize={autosize}
          color={color}
          round={round}
          fullWidth={fullWidth}
          loading={loading ?? false}
          tooltip={tooltip}
          onClick={(event: React.MouseEvent<HTMLElement>) =>
            this.handlePopover(event)
          }
        >
          {children}
        </Button>
        <Popover
          id={utils.uuid()}
          open={this.openPopover}
          anchorEl={this.anchor}
          onClose={() => this.handlePopover(null)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div style={{ ...menuStyle }}>
            {this.functionOrClassMenu ? (
              <PopoverMenu closeMenu={() => this.handlePopover(null)} />
            ) : (
              <PopoverMenu closeMenu={() => {}} />
            )}
          </div>
        </Popover>
      </>
    );
  }
}

const MenuButton = injectStores(MenuButtonComponent);
// const MenuButton = MenuButtonComponent

export { MenuButton };
export default MenuButton;
